import Decimal from 'decimal.js-light';
import { useSystemAssets } from '@bz/systemAssets';

interface CheckWithdrawalLimitParams {
  costCreditAmount: Decimal;
  maxCreditBet: number;
  latestCurrency: string;
  isBonus: boolean;
}

/**
 * 检查投注信用额度是否超过限额
 * @returns true 表示超过限额，已显示弹窗；false 表示未超过限额
 */
export function CheckCreditBetLimit(params: CheckWithdrawalLimitParams): boolean {
  const { costCreditAmount, maxCreditBet, latestCurrency, isBonus } = params;

  if (maxCreditBet < 0 || isBonus) {
    return false;
  }

  const isGreaterThanAvailable = costCreditAmount.greaterThan(new Decimal(maxCreditBet));

  if (isGreaterThanAvailable) {
    pop.push(() => <CreditBetLimitPopupContent maxCreditBet={maxCreditBet} latestCurrency={latestCurrency} />);
    return true;
  }

  return false;
}

/**
 * 信用额度限制弹窗内容组件
 */
function CreditBetLimitPopupContent({
  maxCreditBet,
  latestCurrency,
}: {
  maxCreditBet: number;
  latestCurrency: string;
}) {
  const [assets] = useSystemAssets();
  return (
    <Pop title={t('Credit Limit Exceeded')} class="w-[20rem]">
      <div class="pt-4">
        <img class="size-[6.25rem] mb-4 m-auto" src={assets.betlimitexceededCombo} />
        <p class="mt-2 text-center text-sm text-neutral-main2">
          {t('Maximum credit bet is ')}
          {maxCreditBet} {latestCurrency}
          {t('. Use Cash balance for higher limits.')}
        </p>
        <div class="mt-4 flex items-center">
          <Button class="mr-2 w-full" type="brand" onClick={() => pop.pop()}>
            {t('OK')}
          </Button>
        </div>
      </div>
    </Pop>
  );
}
